module.exports = __webpack_public_path__ + "static/img/image-0.c3b66a68.png";